import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'

export const useStopButtonsStyles = makeStyles(theme => ({
  buttons: {
    marginLeft: theme.spacing(-1),
  },
  deleteButton: {
    color: brandColors.error,
    '&:hover': {
      color: brandColors.error,
    },
  },
}))
